import React from 'react';
import { TextField, useRecordContext } from 'react-admin';
import { hotlineBlocklistFields } from '../../hotlineBlocklist.model';

const formatPhoneForDisplay = (e164Number) => {
    if (!e164Number) return '';
    
    // Handle US numbers starting with +1
    if (e164Number.startsWith('+1')) {
        const digits = e164Number.replace(/^\+1/, '');
        if (digits.length === 10) {
            return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
        }
    }
    
    // Return as-is for non-US numbers or invalid format
    return e164Number;
};

const PhoneNumberField = ({ source = hotlineBlocklistFields.phoneNumber, label = 'Phone Number', ...props }) => {
    const record = useRecordContext();
    if (!record || !record[source]) return null;

    const formattedPhone = formatPhoneForDisplay(record[source]);

    return (
        <TextField 
            source={source} 
            label={label} 
            record={{...record, [source]: formattedPhone}}
            {...props}
        />
    );
};

export default PhoneNumberField; 